import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SpaDetailsRow = styled.div<{ isWrap?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;

  ${({ isWrap }) =>
    isWrap &&
    `
    flex-direction: column;
    flex-wrap: wrap;
  `}

  ${media.xl`
    flex-direction: row;
  `}
`;

export const SpaDetailsCol = styled.div`
  flex-direction: column;
  width: 100%;
`;

export const SpaGuestName = styled.div<{ isBasketDrawer?: boolean }>`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme, isBasketDrawer }) =>
    isBasketDrawer ? theme.defaultColors.fontSecondary : theme.defaultColors.fontPrimary};

  text-transform: uppercase;
  margin-bottom: 8px;
  font-size: 16px;
`;

export const PackageItems = styled.div<{ isBasketDrawer?: boolean }>`
  display: grid;
  color: ${({ theme, isBasketDrawer }) =>
    isBasketDrawer ? theme.defaultColors.fontSecondary : theme.defaultColors.fontPrimary};

  grid-template-columns: 1fr;
  white-space: nowrap;
  gap: 0 10px;
`;

export const PackageItemsName = styled.span``;
